import { request } from "./http";

export interface MarginSnapshot {
  trading_account_id: string;
  balance: string;
  credit: string;
  equity: string;
  margin_used: string;
  free_margin: string;
  margin_level_pct: string | null;
  mc_level_pct: string;
  so_level_pct: string;
}

export const margin = {
  get: (tradingAccountId: string) =>
    request<MarginSnapshot>(`/piggy/api/margin?trading_account_id=${tradingAccountId}`),
};
